/**
 * Contentful Container `fullWidth` (boolean or dropdown string).
 * @param {*} value
 * @returns {'Yes'|'No'|'Yes, Desktop Only'|'Yes, Mobile Only'|null}
 */
export function normalizeContainerFullWidth(value) {
  if (value == null) return null;
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  const s = String(value).trim();
  if (s === 'Yes' || s.toLowerCase() === 'yes') return 'Yes';
  if (s === 'No' || s.toLowerCase() === 'no') return 'No';
  if (s === 'Yes, Desktop Only') return 'Yes, Desktop Only';
  if (s === 'Yes, Mobile Only') return 'Yes, Mobile Only';
  return null;
}
